//
//
//
//
//
//
//
//
import Bus from '@/util/eventBus';
import RulePop from './RulePop.vue';
import Pop from '../Pop/Pop.vue';
import HuoMask from '../HuoMask/HuoMask.vue';
export default {
  components: {
    RulePop: RulePop,
    Pop: Pop,
    HuoMask: HuoMask
  },
  data: function data() {
    return {
      visible: false,
      type: 0
    };
  },
  methods: {
    bindEvent: function bindEvent() {
      var _this = this;

      Bus.$on('showRule', function (type) {
        _this.visible = true;
        _this.type = type;
      });
    }
  },
  mounted: function mounted() {
    this.bindEvent();
  }
};